export default (initialState = {}) => {
  return () => {
    return {
      bill_id: null,
      bill_date: null,
      bill_number: "",
      billing_address: "",
      cn_for: "invoice",
      date: new Date(),
      invc_id: null,
      invc_date: null,
      invc_number: "",
      lineitems: [],
      po_id: null,
      pod_id: null,
      remarks: "",
      seller: null,
      shipping_address: "",
      total_amount: 0,
      tcs: {},
      total_tax: 0,
      type: "Returns",
      type_cd: "returns",
      vehicle_number: "",
      ...initialState,
    };
  };
};
